export default __webpack_public_path__ + "static/media/ForkliftsCars-selected.8aa7a45f.png";